
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["compileCSS"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "e0cf7602db9da354e77a.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			